import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { WorkerStatus } from '../../models/worker';

const MANUALLY_SETTABLE_STATUSES = [
    WorkerStatus.REJECTED,
    WorkerStatus.BLOCKED,
    WorkerStatus.RESERVE_POOL,
] as const;

export function WorkerStatusEditor({
    value,
    error,
    onChange,
    canManageWorkers,
}: {
    value: WorkerStatus;
    error?: boolean;
    onChange: (status: WorkerStatus) => void;
    canManageWorkers: boolean;
}) {
    if (!canManageWorkers) {
        return <TextField label="Status" value={formatStatus(value)} fullWidth size="small" InputProps={{ readOnly: true }} />;
    }

    const statuses = Array.from(new Set<WorkerStatus>([value, ...MANUALLY_SETTABLE_STATUSES]));

    return (
        <FormControl fullWidth size="small" error={error}>
            <InputLabel id="worker-status-label">Status</InputLabel>
            <Select
                id="worker-status"
                labelId="worker-status-label"
                label="Status"
                value={value}
                onChange={(event) => onChange(event.target.value as WorkerStatus)}
            >
                {statuses.map((status) => {
                    const settable = MANUALLY_SETTABLE_STATUSES.includes(status as (typeof MANUALLY_SETTABLE_STATUSES)[number]);
                    const label = formatStatus(status);
                    return (
                        <MenuItem key={status} value={status} disabled={!settable}>
                            {label}{settable ? '' : ' (system-managed)'}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
}

function formatStatus(status: WorkerStatus): string {
    return status.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase());
}
